import React, { useEffect, useState } from 'react';
import ImageModal from '../../../Components/ImageModal';
import ImageLoaderNew from '../../../Components/ImageLoaderNew';

const ImageComparison = ({ data, isDifferentDocs }: any) => {
  const [startIndex, setStartIndex] = useState<number>(0);
  const [imageSrcs, setImageSrcs] = useState<any[]>([]);
  const [imagesByDocType, setImagesByDocType] = useState<any[]>([]);
  const [galleryPop, setGalleryPop] = useState(false);
  const [imgByDocType, setImgByDocType] = useState<Record<number, Record<number, string>>>({});

  
  const processId = data[0]?.processDetails[0]?.processId;
  const taskId = data[0]?.processDetails[0]?.taskDetails[0]?.taskId;

  useEffect(() => {
    const getImages = async () => {
      const result: any[] = [];

      for (const doc of data) {
        const process = doc.processDetails.find((p: any) => p.processId === processId);
        const task = process?.taskDetails.find((t: any) => t.taskId === taskId);
        if (!task) continue;

        result.push({
          docTypeId: doc.docTypeId,
          docTypeName: doc.docTypeName,
          documentCode: doc.documentCode,
          images: task.images
        });
      }
      setImgByDocType({});
      setImageSrcs([]);
      setImagesByDocType(result);
    };

    getImages();
  }, [data, processId, taskId]);

  return (
    <div className="py-3 px-2 image-comparison-container">
      <div className="document-comparison">
        {imagesByDocType.map((doc: any, docIndex: any) => (
          <div key={docIndex} className="document-column">
            {data?.length > 1 && <div className="document-header">
              <h3>{isDifferentDocs ? doc.documentCode : doc?.docTypeName}</h3>
            </div>}
            <div className="image-grid">
              {doc.images.map((image: any, imgIndex: number) => (
                <div
                  key={imgIndex}
                  className={`image-thumbnail ${startIndex === imgIndex ? 'selected' : ''}`}
                   onClick={() => {
                    // const docTypeImages = imgByDocType[doc.docTypeId] || {};
                    const imageArray = doc.images.map((img: any) => ({
                      original: imgByDocType[doc.docTypeId]?.[img.imagePath],
                      key: img.imagePath,
                      comment: img.comment || "",
                    }));

                    setImageSrcs(imageArray);
                    setGalleryPop(true);
                    setStartIndex(imgIndex);
                  }}
                >
                  {image?.imagePath ? 
                    <ImageLoaderNew
                      path={image?.imagePath}
                      index={imgIndex}
                      publicUrl={false}
                      onLoad={(idx: number, url: string) => {
                        setImgByDocType((prev) => {
                          const currentDocTypeImages = prev[doc.docTypeId] || {};
                          return {
                            ...prev,
                            [doc.docTypeId]: {
                              ...currentDocTypeImages,
                              [image?.imagePath]: url,
                            },
                          };
                        });
                      }}
                      notfoundImage={true}
                      style={{ width: '100%', height: 'auto', maxHeight: '120px', objectFit: 'contain' }}
                    /> : <i className="fa-solid fa-image"  style={{color: "gray"}} ></i>}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {galleryPop && (
        <ImageModal
          isOpen={galleryPop}
          imageSrcs={imageSrcs}
          startIndex={startIndex}
          caption={""}
          onClose={() => {
            setGalleryPop(false);
            setImageSrcs([]);
            setStartIndex(0);
          }}
        />
      )}
    </div>
  );
};

export default ImageComparison;
